module.exports = __webpack_public_path__ + "static/media/claudio_etelvino.2563ae94.png";